import {
  Box,
  Drawer,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider,
  CircularProgress,
  IconButton,
  styled,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/system";
import { SouthAfricanRand } from "../../utils/helpers";
import { ProductAvailability } from "../../utils/constants";
import { COLORS } from "../../constants";
import SearchSuggestionsMobile from "../SearchSuggestionsMobile/SearchSuggestionsMobile";
import { getVendors } from "../../api/searchController";
import ResultsSuggestionsMobile from "../ResultsSuggestionsMobile/ResultsSuggestionsMobile";

const StyledInputBase = styled("input")(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(1.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.default,
  border: `1px solid ${COLORS.border}`,
  borderRadius: "2px",
  outline: "none",
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: COLORS.themeRed,
  color: COLORS.white,
  borderRadius: "0 var(--border-radius-s) var(--border-radius-xs) xs",
  padding: theme.spacing(1),
  "&:hover": {
    backgroundColor: COLORS.themeRed, // No hover effect
  },
}));

const MobileSearchPage = ({
  open,
  onClose,
  searchInput,
  setSearchInput,
  products,
  loading,
  handleAddToCart,
  categoriesAndTypes,
}) => {
  const theme = useTheme();
  const searchInputRef = useRef(null);
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    getVendors().then((r) => { if (r?.success) setVendors(r.data ?? []); });
  }, []);

  useEffect(() => {
    if (open && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [open]);

  return (
    <Drawer
      anchor="top"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "100%",
          height: "100vh",
          boxSizing: "border-box",
          borderRadius: "0",
        },
      }}
    >
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          backgroundColor: COLORS.white,
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            flexShrink: 0,
            backgroundColor: COLORS.background,
          }}
        >
          <StyledInputBase
            placeholder="Search…"
            autoFocus
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
            ref={searchInputRef}
          />

          <CloseButton onClick={onClose}>
            <CloseIcon fontSize="small" />
          </CloseButton>
        </Box>

        {(!searchInput.trim() || searchInput.length < 3) && !loading && (
          <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
            <SearchSuggestionsMobile categoriesAndTypes={categoriesAndTypes} vendors={vendors} />
          </Box>
        )}

        {!!searchInput.trim() && (!!products || !!loading) && (
          <ResultsSuggestionsMobile
            searchInput={searchInput}
            loading={loading}
            products={products}
            handleAddToCart={handleAddToCart}
          />
        )}
      </Box>
    </Drawer>
  );
};

export default MobileSearchPage;
